<template>
    <div
        :class="{
            'progress-bar': true,
            'progress-bar--animated': animation,
            [`progress-bar--${theme}`]: (theme || null)
        }"
    >
        <div :style="{ width: `${thePercentage}%`}" class="progress-bar__percentage"></div>
    </div>
</template>

<script>
/**
 * Progress bar.
 * It doesn't watch for percentage property change for performance reasons.
 *
 * @version 4.0.0
 * @example ./examples/ProgressBar.md
 */
export default {
    name: 'ProgressBar',
    props: {
        /**
         * Progress percentage
         */
        percentage: {
            type: [Number, String],
            default: 0,
        },
        /**
         * Theme name, added as BEM modifier
         */
        theme: {
            type: String,
            default: null,
        },
        /**
         * Animated coloring
         */
        animation: {
            type: Boolean,
            default: false,
        },
        /**
         * Max reachable value.
         */
        max: {
            type: Number,
            default: -1,
        },
        /**
         * Rating value.
         */
        value: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            dataPercentage: 0,
        };
    },
    computed: {
        thePercentage() {
            if (this.hasOnlyPercentage) {
                return this.getRightPercentage(this.dataPercentage || 0);
            } else {
                return this.getRightPercentage((this.value / this.max) * 100);
            }
        },
        hasOnlyPercentage() {
            return (
                (this.max < 0 || this.max === null || this.max === undefined) && parseFloat(this.percentage, 10) >= 0
            );
        },
    },
    mounted() {
        if (this.animation) {
            setTimeout(() => {
                this.dataPercentage = this.percentage;
            }, 0);
        } else {
            this.dataPercentage = this.percentage;
        }
    },
    methods: {
        getRightPercentage(value) {
            return Math.max(0, Math.min(value, 100));
        },
    },
};
</script>
